import { Theme } from '@mui/material';
import Box from '@mui/material/Box';
import { SystemStyleObject } from '@mui/system/styleFunctionSx/styleFunctionSx';
import React from 'react';
import { Outlet } from 'react-router-dom';

import { AnnouncementModal } from '@/components/molecules/AnnouncementModal';
import { ApplicationMenu } from '@/components/organisms/ApplicationMenu';

export const DashboardLayout: React.FC = (): React.ReactElement => {
  return (
    <Box sx={styles.viewport}>
      <Box sx={styles.horizontalLayout}>
        <Box sx={styles.menuContainer}>
          <ApplicationMenu />
        </Box>

        <Box sx={styles.contentContainer}>
          <Outlet />
        </Box>
      </Box>
      <AnnouncementModal />
    </Box>
  );
};

const styles: Record<string, SystemStyleObject<Theme>> = {
  viewport: {
    width: '100vw',
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
  },
  horizontalLayout: {
    display: 'flex',
    gap: '60px',
    width: '100%',
    height: '100%',
    backgroundColor: 'custom.AlternativeBackground',
    overflow: 'auto',
    paddingRight: '60px',
  },
  menuContainer: {
    position: 'sticky',
    left: 0,
    top: 0,
    width: 252,
    borderTopRightRadius: '24px',
    borderBottomRightRadius: '16px',
    height: '100%',
    backgroundColor: 'custom.White',
    boxShadow: '0px 5px 40px 0px #00000008',
    zIndex: 1,
  },
  contentContainer: {
    flexGrow: 1,
    flexShrink: 0,
    pt: 7,
    pb: 2,
    height: '100%',
    minWidth: 0,
    maxWidth: 1132,
  },
};
